import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { productCarouselProductFullStyles } from "@dana/Overrides/Components/ProductCarouselProductFull";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

productCarouselProductFullStyles.container = mergeToNew(productCarouselProductFullStyles.container, {
    css: css`
        .discontinued-badge {
            background: ${themeBackgrounds.badgeYellow};
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
            width: auto;
            overflow: visible;
            padding: 4px 16px;

            &.with-overlay {
                left: 0;
                top: 31px;
            }
        }

        .discontinued-title {
            font-size: ${fontSizes.small};
            line-height: ${lineHeights.default};
            color: ${themeColors.danger};
        }
    `,
});

productCarouselProductFullStyles.productImageStyles = mergeToNew(productCarouselProductFullStyles.productImageStyles, {
    linkWrappingImage: {
        css: css`
            max-width: 150px;
            display: block;
            margin: 16px auto;
        `,
    },
    img: {
        css: css`
            max-width: 150px;
        `,
    },
});

productCarouselProductFullStyles.badgeAreaWrapper = mergeToNew(productCarouselProductFullStyles.badgeAreaWrapper, {
    css: css`
        position: initial;

        .badge-wrapper {
            z-index: 2;
            width: auto;
            overflow: visible;
            left: 0;
            top: 0;
            right: unset;

            [class*="TextBadge"] {
                padding: 4px 16px;
                position: relative;
            }
        }
    `,
});

productCarouselProductFullStyles.productInfoHeader = mergeToNew(productCarouselProductFullStyles.productInfoHeader, {
    css: css`
        display: flex;
        align-items: flex-start;
        column-gap: 16px;
        margin-bottom: 8px;
    `,
});

productCarouselProductFullStyles.brandGridItem = mergeToNew(productCarouselProductFullStyles.brandGridItem, {
    css: css`
        flex-basis: 32px;
        max-width: 32px;
        flex-shrink: 0 !important;
        padding: 0;
        max-height: 32px;
    `,
});

productCarouselProductFullStyles.partNumberGridItem = mergeToNew(productCarouselProductFullStyles.partNumberGridItem, {
    css: css`
        padding: 0;
    `,
});

productCarouselProductFullStyles.descriptionGridItem = mergeToNew(
    productCarouselProductFullStyles.descriptionGridItem,
    {
        css: css`
            padding: 0;
            min-height: 40px;
            max-height: 40px;
        `,
    },
);

productCarouselProductFullStyles.productDescriptionStyles = mergeToNew(
    productCarouselProductFullStyles.productDescriptionStyles,
    {
        css: css`
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        `,
    },
);

productCarouselProductFullStyles.productPartNumbersStyles = mergeToNew(
    productCarouselProductFullStyles.productPartNumbersStyles,
    {
        erpNumberValueText: {
            variant: "h3",
            color: themeColors.primary.danaBlue,
            css: css`
                margin-bottom: 0;
            `,
        },
    },
);

productCarouselProductFullStyles.productListActionStyles = mergeToNew(
    productCarouselProductFullStyles.productListActionStyles,
    {
        productCheckAvailabilityLink: {
            link: {
                css: css`
                    @media only screen and (max-width: 1322px) {
                        &.btn {
                            padding: 8px;
                        }
                    }

                    @media only screen and (max-width: 1162px) {
                        &.btn {
                            font-size: ${fontSizes.small};
                            line-height: ${lineHeights.small};
                        }
                    }
                `,
            },
        },
    },
);
